import {
	getPassColor,
	PassCircle,
} from "@/pages/catalogs/pages/edger-rolls/components/passes/PassesGrid";
import { Box, Tooltip, Typography, useTheme } from "@mui/material";

export const RollPassStatus = ({
	passesStatus,
	passesSections,
	justifyContent = "flex-end",
	withLabel = true,
}: {
	passesStatus?: string | null;
	passesSections?: string | null;
	justifyContent?:
		| "flex-start"
		| "flex-end"
		| "center"
		| "space-between"
		| "space-around"
		| "space-evenly";
	withLabel?: boolean;
}) => {
	if (!passesStatus) {
		return null;
	}

	const theme = useTheme();
	const passes = passesStatus.split(",");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: "100%",
				height: "100%",
			}}
		>
			{withLabel && (
				<Typography
					variant="body2"
					fontSize={12}
					color="text.secondary"
					textAlign="center"
				>
					Available Passes
				</Typography>
			)}

			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent,
					flexWrap: "wrap",
					gap: 0.5,
				}}
			>
				{passes.map((c, index) => {
					const isReady = c === "R";
					const isUsed = c === "U";
					const sections = passesSections?.split("|") ?? [];
					const sectionsPerPass = sections ? sections[index] : [];

					const tooltipTitle = (
						<Box>
							<Typography variant="caption">
								Pass {index + 1}:{" "}
								{isReady ? "Ready" : isUsed ? "Used" : "Damaged"}
							</Typography>
							{sectionsPerPass && (
								<>
									<Typography
										variant="caption"
										display="block"
										sx={{ opacity: 0.8 }}
									>
										Sections:
									</Typography>
									<Typography variant="caption" display="block">
										{sectionsPerPass}
									</Typography>
								</>
							)}
						</Box>
					);

					return (
						<Tooltip title={tooltipTitle} arrow>
							<span>
								<PassCircle
									sx={{ fontSize: 14 }}
									firstColor={getPassColor(c, theme).main}
								/>
							</span>
						</Tooltip>
					);
				})}
			</Box>
		</Box>
	);
};
